module.exports = __webpack_public_path__ + "img/list_policy.b40d7f75.png";